import getApi from '../../api'
import { Prescription } from '../../model/Prescription'

export const getPrescription = (prescriptionId: string, signal?: AbortSignal) =>
  getApi().get<Prescription>(`/prescriptions/${prescriptionId}`, undefined, { signal })
